<div class="top-header">
    <div class="title-action-container">
        <div class="title-container">
            <div class="company-name" appFsMask>{{companyName}}</div>
            <div class="separator"> |</div>
            <div *ngIf="document && !(document?.embeddedWorkflow) && !isVendorData; else staticDocName" class="document-name">
                <a target="_blank" [routerLink]="['/review', document.id, 'fullscreen']">
                    <span class="document-name-text" [title]="documentName" appFsMask>{{documentName}}</span><i
                    class="fas fa-arrow-up-right-from-square"></i></a>
            </div>
            <ng-template #staticDocName>
                <div class="static-document-name">
                    <span class="document-name-text" [title]="documentName" appFsMask>{{documentName}}</span>
                </div>
            </ng-template>
        </div>
        <div class="action-container">
            <ng-content select="[header-action]"></ng-content>
            <div class="doc-status-btns">
                <i *ngIf="currentStep === 'Spreading'"
                   class="fas fa-keyboard toolbar"
                   (click)="openShortcutsModal()"
                   title="Keyboard Shortcuts">
                </i>

        @if (!embedded && showDocumentStatusButton) {
          <a
            class="clickable"
            href="javascript:void(0);"
            #uploadStatusOrigin
            (click)="showUploadStatusPopover = !showUploadStatusPopover"
            >
            <div class="avatar">
              <i class="far fa-check-square"></i>
            </div>
          </a>
          <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="uploadStatusOrigin"
            [cdkConnectedOverlayOpen]="showUploadStatusPopover"
            [cdkConnectedOverlayHasBackdrop]="true"
            cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
            [cdkConnectedOverlayPositions]="[
              {originX:'center',originY:'bottom',overlayX:'center',overlayY:'top'},
              {originX:'end',originY:'bottom',overlayX:'end',overlayY:'top'},
              {originX:'start',originY:'bottom',overlayX:'start',overlayY:'top'}
            ]"
            [cdkConnectedOverlayPush]="true"
            (backdropClick)="showUploadStatusPopover = false">
            <app-upload-status-popover
              (closePopover)="showUploadStatusPopover = false"
              [isManualReviewer]="shouldDisplayManualReview()"
              [isSpreader]="shouldDisplaySpreading()"
              >
            </app-upload-status-popover>
          </ng-template>
        }
        @if (!embedded) {
          <div class="dropdown">
            <a href="#" id="nbAcctDD" class="dropdown-toggle-no-caret" data-bs-toggle="dropdown">
              <div class="avatar">
                <i class="far fa-question-circle"> </i>
              </div>
            </a>
            <ul class="dropdown-menu dropdown-menu-end">
              @if (showNumeratedSalesforceHelpLinks) {
                @if (userGuideService.userGuides.length > 0) {
                  <li class="walkthrough-header"><strong>Articles</strong>
                </li>
              }
              @for (userGuide of userGuideService.userGuides; track userGuide) {
                <li>
                  <a target="_blank" href="{{userGuide.url}}" class="dropdown-item">{{userGuide.name}}</a>
                </li>
              }
              @if (userGuideService.userGuides.length > 0) {
                <li
                role="separator" class="dropdown-divider"></li>
              }
              <li class="user-guide">
                @if (shouldShowInstructionsInDropdown) {
                  <div class="dropdown-item no-hover-background" (click)="onTextClick($event)">
                    <input [checked]="_sharedDataService.shouldShowManualReviewSidebar" type = "checkbox" class = "fas fa-checkbox">
                    <span class = "instruction-text">Show Instructions</span>
                  </div>
                }
              </li>
              <li class="user-guide">
                <a target="_blank" href="https://information.moodysanalytics.com/000000AJZUSRBLSUSR/introduction" class="dropdown-item">
                  <i class="fas fa-clipboard-user"></i>User Guide
                </a>
              </li>
            }
            @if (showStorylaneTrainingButton) {
              <li class="how-to-use-numerated">
                <a target="_blank" href="https://numerated.storylane.io/share/mbgtcrj0yghv" class="dropdown-item">
                  <i class="fas fa-book"></i>How to Use Numerated
                </a>
              </li>
            }
            @if (customerSupportUrl || contactSupportEmail) {
              <li role="separator" class="dropdown-divider"></li>
              <li class="contact-support-option">
                <a class="dropdown-item"
                  (click)="openContactSupportEmailModal()">
                  <i class="fas fa-question-circle"></i>Contact Support
                </a>
              </li>
            }
          </ul>
        </div>
      }
    </div>
    @if (!embedded) {
      <button
        class="btn btn-outline-secondary header-action-btn"
        type="button"
        (click)="navigate('back')"
        >
        <span class="size">Exit</span>
      </button>
    }

    @if (!embedded) {
      <div class="btn-separator">|</div>
    }

    <button
      class="btn btn-light-primary"
      type="button"
      [disabled]="actionsDisabledForReSpreadLock"
      (click)="save()"
      >
      <span class="size">Save</span>
    </button>

    <button
      class="btn btn-primary"
      type="button"
      [disabled]="actionsDisabledForReSpreadLock"
      [ngClass]="{'btn-secondary': actionsDisabledForReSpreadLock}"
      (click)="next()"
      >
      @if (currentStep !== 'Spreading') {
        <span class="size">Next</span>
      }
      @if (currentStep === 'Spreading') {
        <span class="size">Complete</span>
      }
    </button>
  </div>

</div>
<div class="stepper-and-page-action-container">
  <app-navigation-stepper
    [steps]="navigationSteps"
    [currentStepIndex]="currentStepIndex"
  ></app-navigation-stepper>
  <div class="page-action-container">
    <ng-content></ng-content>
  </div>
</div>
</div>
